import { IconDraggable } from 'uikit';

import type React from 'react';
import { useCallback, useContext } from 'react';

import type { ITableLikeTreeItem } from '../context';
import { TableLikeTreeContext } from '../context';

interface IDragButton {
    treeItem: ITableLikeTreeItem;
    isDragAndDropDisabled?: boolean;
}

export const DragButton: React.FC<IDragButton> = (props) => {
    const { treeItem, isDragAndDropDisabled = false } = props;
    const { onDragStart } = useContext(TableLikeTreeContext);

    const dragStartHandler = useCallback(
        (cb: (item: ITableLikeTreeItem) => any) => () => {
            if (isDragAndDropDisabled) {
                return;
            }

            cb(treeItem);
        },
        [isDragAndDropDisabled, treeItem],
    );

    return (
        <IconDraggable
            size="xs"
            view="ghost"
            draggable={!isDragAndDropDisabled}
            onDragStart={!isDragAndDropDisabled ? dragStartHandler(onDragStart) : undefined}
            style={
                isDragAndDropDisabled
                    ? {
                          cursor: 'not-allowed',
                      }
                    : {
                          cursor: 'grab',
                      }
            }
        />
    );
};

DragButton.displayName = 'DragButton';
